import PropTypes from 'prop-types';
import Icon from 'components/elements/icon';
import { Button } from '@evertrue/et-components';

const PhoneTemplate = ({ data, hideIcon, onClick = () => {} }) => (
  <div className="phone-template">
    {hideIcon ? <div className="phone-template--no-icon" /> : <Icon icon="call" className="phone-template--icon" />}

    {!data?.phone ? (
      <div className="phone-template--data is-empty">Not provided</div>
    ) : (
      <div className="phone-template--data">
        <div className="phone-template--label">
          {data?.type || 'Other'}
          {data?.primary && ' (Primary)'}
        </div>
        <Button
          type="simple"
          className="email-template--button email-template--button-blue"
          onClick={() => {
            onClick(data.phone);
          }}
        >
          {data.phone}
        </Button>
      </div>
    )}
  </div>
);

PhoneTemplate.propTypes = {
  data: PropTypes.object,
  hideIcon: PropTypes.bool,
  onClick: PropTypes.func,
};

export default PhoneTemplate;
